import styled from "@emotion/styled";
import { DetailedHTMLProps, HTMLAttributes } from "react";
import { Dropdown, Form } from "react-bootstrap";
import styledConst from "styles";

export const BlueText = styled.span`
    color: ${styledConst.Primary_Blue_4};
    letter-spacing: -0.224px;
    font-size: 14px;

    &.large {
        font-size: 1.125rem;
    }
`;

export const Box = styled.div`
    background-color: #3e4b67;
    border-radius: 5px;
    min-width: 220px;
    padding: 12px 15px;

    &.light {
        background-color: #ffffff;
        border: 2px solid #eaeaea;
    }
`;

export const SelectedGreenBox = styled(Box)`
    &.selected {
        border: 2px solid ${styledConst.Primary_Green_1};
    }
`;

export const RowBox = styled.div`
    background-color: ${styledConst.Primary_Blue_3};
    padding: 15px 12px;
    border-radius: 4px;
    margin-top: 10px;
    display: inline-block;
    width: 100%;
`;

const Arrow = styled.i`
    color: ${styledConst.Primary_Green_1};
`;

export const ArrowIcon = ({
    children = "keyboard_arrow_right",
    className,
}: DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>) => (
    <Arrow className={`material-icons ${className}`}>{children}</Arrow>
);

const Remove = styled.i`
    color: ${styledConst.Secondary_Red};
    cursor: pointer;
`;

export const RemoveIcon = ({
    children = "close",
    className,
    ...restProps
}: DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>) => (
    <Remove className={`material-icons ${className}`} {...restProps}>
        {children}
    </Remove>
);

export const ColorPickerBackground = styled.div<{ $inputColor: string }>`
    background-color: ${(props) => props.$inputColor} !important;
`;

export const BlueRadio = styled(Form.Check)`
    .custom-control-label {
        &::before {
            top: calc(50% - 11px);
            width: 22px;
            height: 22px;
        }

        &::after {
            top: calc(50% - 4px);
            left: -17px;
            height: 8px;
            width: 8px;
        }
    }

    .custom-control-input:checked ~ .custom-control-label::after {
        background-image: none;
        background-color: #3a4763;
        border-radius: 50%;
    }
    .custom-control-input:disabled ~ .custom-control-label {
        cursor: no-drop;
    }
`;

export const LightRadio = styled(BlueRadio)`
    .custom-control-label:before {
        background-color: #dddddd;
        border: 1px solid #dddddd;
    }

    .custom-control-input:checked ~ .custom-control-label::after {
        background-color: ${styledConst.Secondary_Green};
    }

    .custom-control-input:checked ~ .custom-control-label::after {
        background-image: none;
        background-color: #ffffff;
        border-radius: 50%;
    }

    .custom-control-input:disabled ~ .custom-control-label {
        color: #2f3a51;

        &::before {
            background-color: #dddddd;
        }
    }
`;

export const CustomDropdown = styled(Dropdown)`
    > .dropdown-toggle {
        color: ${styledConst.Neutral_Grey_2};
        background-color: #f0f0f0;
        border-color: #f0f0f0;
        padding: 0.375rem;
        text-align: left;
        width: 100%;

        &.btn-primary:hover,
        &.btn-primary:not(:disabled):not(.disabled):active,
        &.btn-primary:focus {
            color: ${styledConst.Neutral_Grey_2};
            background-color: #f0f0f0;
            border-color: #f0f0f0;
        }

        &::after {
            display: none;
        }
    }

    &.dark {
        > .dropdown-toggle {
            color: #ffffff;
            background-color: #242d41;
            border-color: #36425c;

            &.btn-primary:hover,
            &.btn-primary:not(:disabled):not(.disabled):active,
            &.btn-primary:focus {
                color: #ffffff;
                background-color: #242d41;
                border-color: #36425c;
            }

            .material-icons {
                color: ${styledConst.Primary_Blue_4};
            }
        }

        &.show {
            > .dropdown-toggle {
                color: #ffffff;
                background-color: #242d41;
                border-color: #36425c;
            }
        }

        .dropdown-menu {
            background: #242d41;
        }

        .dropdown-item {
            color: #ffffff;
        }

        .form-control.search {
            background-color: #242d41 !important;
            border-color: ${styledConst.Primary_Blue_2}!important;
            color: ${styledConst.Primary_Blue_4}!important;
        }
    }

    &.show {
        > .dropdown-toggle {
            color: ${styledConst.Neutral_Grey_2};
            background-color: #f0f0f0;
            border-color: #f0f0f0;
        }
    }

    .dropdown-menu-content {
        overflow-y: scroll;
        max-height: 300px;

        &::-webkit-scrollbar {
            width: 8px;
            border-radius: 8px;
        }
        &::-webkit-scrollbar-track {
            border-radius: 8px;
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 8px;
            background-color: #d9d9d9;
        }
    }

    .dropdown-item.active {
        background-color: ${styledConst.Primary_Green_1};
    }

    .dropdown-item:hover {
        background-color: #3e4b67;
    }

    .form-control.search {
        background-color: #ffffff !important;
        border-color: #f0f0f0 !important;
        color: #2f3a51 !important;
    }

    @media screen and (max-width: 768px) {
        .dropdown-header,
        .dropdown-item {
            padding: 0.5rem;
        }

        .dropdown-menu-content {
            max-height: 250px;
        }
    }
`;
